'use client'

import { DemoRequest } from '@/app/components/DemoRequest/DemoRequest'
import { useDemoRequestModal } from '@/app/components/DemoRequest/DemoRequestModalContext'
import { Modal } from '@/app/components/Modal'

export const DemoRequestModal = () => {
  const { isOpen, closeModal } = useDemoRequestModal()

  const demoFormData = {
    _type: 'demoForm' as const,
    heading: undefined,
    subheading: undefined,
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={closeModal}
      variant="centered"
      showBackdrop={true}
      showCloseIcon={true}
      closeIconSize={14}
      preserveScrollPosition={true}
      classNames={{
        backdrop: 'bg-black/70',
        root: '!px-md md:!px-4xl',
        inner:
          'max-w-[1100px] w-full p-0 overflow-y-auto max-h-[90vh] rounded-none !bg-transparent',
        closeIcon:
          'btn-secondary !absolute !top-sm !right-sm !mt-0 !mr-0 w-[44px] h-[44px] md:w-[52px] md:h-[52px] bg-neutral-50 rounded-xss text-neutral-950 hover:bg-neutral-100 active:bg-neutral-200 flex items-center justify-center',
      }}
    >
      <DemoRequest demoForm={demoFormData} displayMode="modal" />
    </Modal>
  )
}
